export const SEARCH_DEBOUNCE_DELAY = 300 // ms
export const SEARCH_MIN_QUERY_LENGTH = 2
